module.exports = __webpack_public_path__ + "static/media/value-poster-2.4b9cfe94.png";